module.exports = __webpack_public_path__ + "img/inncash-comunity-call-background.51ec675b.webp";